<template>
  <section class="content">
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type == 'success' || alert.type == 'warning' "class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{'alert_'+alert.type | translate}}!</h4>
        {{alert.message}}
      </b-alert>
    </template>
    <div class="row">
      <div class="col-xs-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title"><i class="fa fa-user mr-5"></i>{{'controlling_stats' | translate}}</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
            </div>
          </div>
          <div class="box-controls">
            <div class="row">
              <div class="col-md-4 col-sm-6">
                <div class="input-group">
                  <div class="input-group-addon">
                    {{'date' | translate}}:
                  </div>
                  <vue-monthly-picker v-if="!cancelTab" dateFormat="YYYY-MM" class="form-control" v-model="selectedMonth" @selected="dateChange" :max="endRange"></vue-monthly-picker>
                  <date-range-picker  v-else :startDate="startRange" :endDate="endRange" @pepe="dateChange" id="sales"></date-range-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="box-body">
            <div class="row pt-10">
              <div class="col-xs-12">
                <div class="overlay" v-if="loading">
                  <img class="loading-gif" src="/static/img/blabla.svg"/>
                </div>
                <div class="nav-tabs-custom" v-else>
                  <ul class="nav nav-tabs">
                    <li class="active"><a @click="cancelTab=false" href="#tab_2-1" data-toggle="tab" aria-expanded="true"><i class="fa fa-shopping-cart mr-5 "></i>{{'sales' | translate}}</a></li>
                    <li class=""><a @click="cancelTab=true" href="#tab_2-2" data-toggle="tab" aria-expanded="false"><i class="fa fa-ban mr-5 text-danger"></i>{{'cancellations' | translate}}</a></li>
                  </ul>
                  <div class="tab-content">
                    <div id="tab_2-1" class="tab-pane active">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th>{{'sales_channel'| translate}}</th>
                              <th>{{'sales' | translate}}</th>
                              <th>{{'returns' | translate}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in Object.keys(sales)">
                              <template v-if="item !== 'tamaris'">
                                <td>
                                  <img class="img-responsive img-channel pull-left" :src="`/static/img/${item}.svg`">
                                </td>
                                <td v-if="typeof sales[item].order !== 'undefined'">
                                <tr>
                                  <td>
                                    <strong>{{'date_range' | translate}}:</strong>
                                    {{sales[item].order.start_date | orderDateApi}} - {{sales[item].order.end_date | orderDateApi}}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>{{'gross_amount' | translate}}:</strong>
                                    {{sales[item].order.gross_amount | currency}}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>{{'gross_fee_total' | translate}}:</strong>
                                    {{sales[item].order.gross_fee_total | currency}}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>{{'sales' | translate}}:</strong>
                                    {{sales[item].order.sales}}
                                  </td>
                                </tr>
                                </td>
                                <td v-if="typeof sales[item].return !== 'undefined'">
                                  <tr>
                                    <td>
                                      <strong>{{'date_range' | translate}}:</strong>
                                      {{sales[item].return.start_date | orderDateApi}} - {{sales[item].return.end_date | orderDateApi}}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>{{'gross_amount' | translate}}:</strong>
                                      {{sales[item].return.gross_amount | currency}}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>{{'gross_fee_total' | translate}}:</strong>
                                      {{sales[item].return.gross_fee_total | currency}}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>{{'returns' | translate}}:</strong>
                                      {{sales[item].return.sales}}
                                    </td>
                                  </tr>
                                </td>
                              </template>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div id="tab_2-2" class="tab-pane">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th>{{'sales_channel'| translate}}</th>
                              <th>{{'cancellations' | translate}}</th>
                              <th>{{'gross_cancellation_amount' | translate}}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in Object.keys(cancellations)">
                              <td>
                                <img class="img-responsive img-channel" :src="`/static/img/${item}.svg`">
                              </td>
                              <td>
                                {{cancellations[item].cancellation}}
                              </td>
                              <td>
                                {{cancellations[item].gross_cancellation_amount | currency}}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import VueMonthlyPicker from 'vue-monthly-picker'
export default {
  data() {
    return {
      alerts: [],
      sales: {},
      cancellations: {},
      cancelTab: false,
      loading: false,
      startRange: moment().subtract(1, 'month'),
      endRange: moment(),
      selectedStart: '',
      selectedEnd: '',
      selectedMonth: moment().subtract(1, 'month'),
    }
  },
  components: {
    vueMonthlyPicker: VueMonthlyPicker
  },
  methods: {
    dateChange (picker) {
      if (!this.cancelTab) {
        API.post('controlling/stats/sales', {month:this.selectedMonth.format('YYYY-MM')})
          .then(response => {
            this.sales = response.data
          })
          .catch(error => {
            let alert = {type: 'danger', dismiss: 4, message: this.translate(error.body.error_code) || error.body.error_message}
            this.alerts.push(alert)
          })
      } else {
        this.startRange = picker.startDate
        this.endRange = picker.endDate
        this.selectedEnd = this.endRange.format('YYYY-MM-DD')
        this.selectedStart = this.startRange.format('YYYY-MM-DD')

        API.post('controlling/stats/cancellations', {start_date:this.selectedStart, end_date:this.selectedEnd})
          .then(response => {
            this.cancellations = response.data
          })
          .catch(error => {
            let alert = {type: 'danger', dismiss: 4, message: this.translate(error.body.error_code) || error.body.error_message}
            this.alerts.push(alert)
          })
      }

    }
  },
  mounted () {
    API.post('controlling/stats/sales')
      .then(response => {
        this.sales = response.data
      })
      .catch(error => {
      })

    API.post('controlling/stats/cancellations', {start_date:this.startRange.format('YYYY-MM-DD'), end_date:this.endRange.format('YYYY-MM-DD')})
      .then(response => {
        this.cancellations = response.data
      })
      .catch(error => {
      })
  }
}
</script>
<style>

  .date-popover {
    overflow-x: hidden;
    overflow-y: hidden;
    outline: none;
    max-width: 350px;
    width: 100%;
    border-radius: 0 0 .28571429rem .28571429rem;
    box-shadow: 0 2px 3px 0 rgba(34,36,38,.15);
    background: #212228 !important;
    transition: opacity .1s ease;
    position: relative;
    margin: auto;
    z-index: 10;
    border: 1px solid;
    font-size: 1rem;
    font-weight: 200;
  }
  .picker .monthItem .item.active:hover{
    border-top: 1px solid;
    cursor: pointer;
    background-color: rgba(0,195,150,.4) !important;
    border-color: rgba(0,195,150,1) !important;

  }

</style>



// WEBPACK FOOTER //
// src/components/views/ControllingStatsView.vue